import React from 'react';
import { bool, func, node, shape, string } from 'prop-types';
import { Button, useTheme } from '@mui/material';

import { EmptyList, PermissionGate, ResourceCards, Spinner } from '../../../../../../components';
import ApplicationHeader from '../../../ApplicationHeader';
import WebhooksStatus from '../WebhooksStatus';

import staticText from '../../../../../../localization/Application/webhooks';

const WebhooksHome = ({
  webhooks,
  openWebhookModal,
  isFetchingWebhooks,
  upgradeCta,
  upgradeAgainMessage,
}) => {
  const theme = useTheme();

  const hasWebhooks = Object.keys(webhooks).length > 0;

  return (
    <React.Fragment>
      <ApplicationHeader
        heading={staticText.heading}
        rightSideContent={(
          <PermissionGate dashboardPermission="write_webhooks">
            <Button
              variant="outlined"
              onClick={openWebhookModal}
            >{staticText.addWebhookButton}
            </Button>
          </PermissionGate>
        )}
      />
      {/* eslint-disable-next-line no-nested-ternary */}
      {hasWebhooks ? (
        <WebhooksStatus webhooks={webhooks} upgradeMessage={upgradeAgainMessage} />
      ) : (
        isFetchingWebhooks ? (
          <Spinner size="small" spinnerColor={theme.palette.grey[200]} additionalClassNames="spinner-page" />
        ) : (
          <EmptyList
            text={staticText.emptyState.text}
            cta={{
              text: staticText.emptyState.cta.text,
              onClick: openWebhookModal,
            }}
            dashboardPermission="write_webhooks"
            upgradeCta={upgradeCta}
          />
        )
      )}
      <ResourceCards cards={staticText.resourceCards} />
    </React.Fragment>
  );
};

export default WebhooksHome;

WebhooksHome.propTypes = {
  webhooks: shape({}),
  openWebhookModal: func.isRequired,
  isFetchingWebhooks: bool.isRequired,
  upgradeCta: node,
  upgradeAgainMessage: string,
};

WebhooksHome.defaultProps = {
  webhooks: {},
  upgradeCta: null,
  upgradeAgainMessage: null,
};
